export const alertIcon = {
  data: `<svg>
          <g fill-rule="evenodd">
            <path stroke-linecap="round" d="M4.5 4.5l7 7" />
            <path opacity=".99" stroke-linecap="round" d="M11.5 4.5l-7 7" />
            <circle cx="8" cy="8" r="7.5" />
          </g>
        </svg>`,
  name: 'alert',
};
